import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  validateButton: {
    width: 110,
    height: 34,
    textTransform: 'none',
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '18px',
    backgroundColor: '#DF0C36',
    marginBottom: 16,
    marginRight: 16,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#B00429',
    },
  },
  dialogText: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '20px',
    margin: '8px 16px 32px 16px',
    color: '#666666',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '12px',
    lineHeight: '20px',
    margin: 'auto 16px',
    color: '#666666',
  },
  dialog: {
    width: 300,
    height: 200,
  },
}));
